<template>
  <el-dialog
    append-to-body
    :visible.sync="innerVisible"
    :title="$t('CargoMsg.Cargo_InvoicePool')"
    width="1200px"

    :close-on-click-modal="false"
  >
    <invoice-pool-common
      ref="invoicePoolCommon"
      :is-dialog="true"
      :seller-tax-name-default-value="sellerTaxNameDefaultValue"
      :default-has-attachment="operation === 'collection'"
    />
    <div slot="footer">
      <el-button type="primary" no="confirm" @click="confirm">{{ $t('common.btn.confirm') }}</el-button>
      <el-button no="cancel" @click="innerVisible=false">{{ $t('common.btn.cancel') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import invoicePoolCommon from '@/views/cargo/v0/Clearing/components/invoicePool/invoicePoolCommon'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import * as NumberUtils from '@/utils/NumberUtils'
import { multiply } from '@/utils/commonUtil'
import * as InvoiceConstant from '@/class/cargo/model/parameters/InvoiceConstant'
import { getLoading, getLoading4Cxt } from '@/utils/utilBaseElement'
import { generateInvoiceForPool, getNotInvoiceCharges } from '@/api/clearing/invoice'
import { cache } from '@/utils/cacheManager'
import { queryInvoiceGoodsName } from '@/api/clearing/invoiceGoodsName'

export default {
  name: 'InvoicePoolDialog',
  components: { invoicePoolCommon },
  props: {
    visible: { type: Boolean, required: true },
    sellerTaxNameDefaultValue: { type: String, default: '' }, // 销方名称 高级查询 默认值
    selectedEntities: { type: Array, default: () => [] },
    operation: { type: String, default: '' },
    source: { type: String, default: '' },
    makeInvoiceMethod: { type: Number, default: 1 },
    callback: { type: Function, default: null }
  },
  data() {
    return {
      innerVisible: false,
      properties: {
        // mode: 0, // 弹窗模式[default:0] 0-开票模式  1-对冲开票模式
        isHedge: false, // 是否对冲
        isAr: false, // 是否应收
        makeInvoiceMethod: 1, // 开票方式: 1=费用、2=业务、3=账单、4=对账单
        makeInvoiceMethodHedge: 1, // 开票方式: 1=费用、2=业务、3=账单、4=对账单
        typeGroup: 'multi', // 开票类型：multi=合并开票、job=按业务开票、single=按记录开票、settlementAgent=按结算代理开票
        invoiceType: 0, // 发票类型：0=普通发票、1=专用发票、2=增值税普通发票、3=增值税专用发票、4=内部发票
        groupingMakeType: 1, // 发票种类：0=纸质发票、1=电子发票

        currencyGroup: 0, // 分币种开票：0=拆分币种开票、1=合并币种
        cbAssignCurrency: true, // 指定发票币种
        groupingCurrencyType: 0, // currencyGroup + cbAssignCurrency: 0=合并币种、1=拆分币种+指定发票币种、2=拆分币种+非指定发票币种
        currency: 'RMB', // 币种

        showChargeDetail: false, // 是否显示费用明细
        useDefaultRate: false, // 按财务汇率开票
        isInvoicingByBillingRate: false, // 按账单汇率
        billingRateMap: {}, // 账单币种、账单汇率
        makeCostInvoice: false, // 生成成本发票
        billPreInvoicing: false, // 根据账单开票要求开票
        isGenCostInvoice: false, // 是否生成成本发票: isAr ? makeCostInvoice : false
        costInvoiceProp: {},
        defaultContent: false, // 将本次内容设置为默认开票信息

        invoiceGoodsName: {}, // 发票项目名称
        settleDepartment: 0, // 结算部门
        settleDepartmentPrefix: '', // 结算部门归属工作号

        otherCurrencys: [], // 其它币种
        otherRates: [], // 其它币种汇率
        txtCurrency1: '',
        txtRate1: '',
        txtCurrency2: '',
        txtRate2: '',
        rateCache: {}, // 对比发票币种的汇率
        cbAlwarysUseRate: false, // 一直按该汇率开票

        branchId: this.$store.getters.currentOfficeId, // 分公司 Session.getInstance().getOfficeId()
        inputByDep: this.$store.getters.currentDeptId, // 部门 Session.getInstance().currentDepartment.departmentId

        titleMap: {}, // 获取账单所对应的结算单位: getTitleMap()
        invoiceByType: '', // 确认是否应当添加账单中的开票需求: getClassType(entities)
        hedgeInvoiceByType: '', // 确认是否应当添加账单中的开票需求: getClassType(hedgeEntities)

        selectedEntities: [], // 已经选中的实体
        selectedEntitiesHedge: [], // 已经选中的对冲实体
        entities: [], // 开票实体
        hedgeEntities: [], // 对冲实体
        allEntities: [], // 所有实体
        allCharges: [],
        chargeMap: {},
        invoices: [], // 生成发票列表
        invoice: {}, // 当前发票
        currentPage: 1, // 顺序号
        totalPage: 0, // 发票总数
        invoiceGoodsNameList: [], // 发票项目名称列表
        invoiceItemGoodsName: 0, // InvoiceItemGoodsName：开票发票项目默认货物或应税劳务名称
        defaultGoodsName: '', // InvoiceMergeName：合并开票费用名称
        receivedRadio: 'ALL', // 对冲开票，应收列表币种：全部/RMB/USD
        paymentRadio: 'ALL', // 对冲开票，应付列表币种：全部/RMB/USD
        showChargeDetailByInvoice: false, // ShowChargeDetailByInvoice：增值发票是否可以显示明细
        invoiceNoEditable: false, // InvoiceSearchEdit: 开票查询修改发票号
        costInfo: false, // costSplitInfo: 是否开启费用拆分金额校验
        isInvoicingByBusinessDateRate: false, // 按业务日期汇率收票
        useAutoCheckInvoicing: false, // 是否使用了自动勾选开票
        autoCheckInvoicingAmount: 0.00, // 自动勾选最大金额
        autoCheckInvoiceAmountEnable: false, // 自动勾选最大金额是否可用
        specificConstraintType: '', // 特定约束类型
        settlementCenterMode: false, // 锦昶共享中心
        isInvoicingByTaxRate: false, // 按税点分组开票
        rbgShowChargeDetail: '' // 显示明细
      }
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.visible) {
      this.innerVisible = true
      this.initConfig()
    }
  },
  methods: {
    // 配置参数
    async initConfig() {
      this.properties.invoiceItemGoodsName = Number(cache.config.get('InvoiceItemGoodsName'))
      this.properties.defaultGoodsName = String(cache.config.get('InvoiceMergeName'))
      this.properties.showChargeDetailByInvoice = String(cache.config.get('ShowChargeDetailByInvoice')) === '1'
      this.properties.invoiceNoEditable = String(cache.config.get('InvoiceSearchEdit')) === '1'
      this.properties.costInfo = Number(cache.config.get('costSplitInfo')) === 1
      this.properties.enableCustomizeRevokeInvoice = Number(cache.config.get('enableCustomizeRevokeInvoice')) === 1
      this.properties.interfaceName = String(cache.config.get('TaxControlInterfaceName'))
      this.properties.interfaceNameEI = String(cache.config.get('EITaxControlInterfaceName'))
      this.properties.terminalSn = String(cache.config.get('baiWangOriginTerminalSN'))
      this.properties.storageURL = String(cache.config.get('StorageURL'))
      this.properties.isInvoiceByEachBillingRate = Number(cache.config.get('isInvoiceByEachBillingRate')) === 1
      this.properties.toExoSystemYGSH = String(cache.config.get('ToExoSystem')) === 'YGSH' // 阳光速航
      this.properties.toExoSystemHC = String(cache.config.get('ToExoSystem')) === 'HC' // 海创
      this.properties.QdWarning = String(cache.config.get('QdWarning')) !== '0' // 全电接口-国税应急方案
      this.properties.FeiByAuth = Number(cache.config.get('FeiByAuth')) === 1 // 全电接口是否走实人认证
      this.properties.settlementCenterMode = String(cache.config.get('SettlementCenterMode')) === '1' // 锦昶共享中心
      this.properties.isEasyInoivceVietnam = this.properties.interfaceNameEI === InvoiceConstant.INVOICE_EASY_INOIVCE_VIETNAM // 杰贝越南税控
      this.properties.isBillPreInvoicing = String(cache.config.get('BillingNoteContainInvoiceReques')) // 太平账单预开发票
    },
    async confirm() {
      if (!this.$refs.invoicePoolCommon.selectedRows || this.$refs.invoicePoolCommon.selectedRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectData'))
        return
      }
      if (this.$refs.invoicePoolCommon.selectedRows.length > 1) {
        this.$message.warning(this.$t('Clearing.PleaseSelectOnlyOneRecord'))
        return
      }
      if (this.operation === 'collection') { // 收票
        if (!await this.collectionInvoice()) {
          return
        }
      } else {
        this.$emit('confirm', this.$refs.invoicePoolCommon.selectedRows[0])
      }
      if (this.callback != null) {
        await this.callback(this.properties.invoices || [])
      }
      this.innerVisible = false
    },
    async collectionInvoice() {
      const selectedRow = this.$refs.invoicePoolCommon.selectedRows[0]
      this.properties.selectedEntities = this.selectedEntities

      await this.initMakeInvoice()
      const flag = await this.initEntities()
      if (!flag) {
        return false
      }

      const localCurrency = RateUtil.localCurrencyByOffice()
      let total = 0
      for (const item of this.properties.entities) {
        const index = 1
        if (item.currency === localCurrency) {
          total += NumberUtils.ToFixed2(multiply(item.amount, index), 2)
        } else {
          total += NumberUtils.ToFixed2(multiply(item.localAmount, index), 2)
        }
        total = NumberUtils.ToFixed2(total, 2)
      }
      console.log('total', total, 'selectedRow.totalAmount', selectedRow.totalAmount)
      if (NumberUtils.ToFixed2(total - selectedRow.totalAmount, 2) > 0.01) {
        this.$message.warning(this.$t('CargoMsg.Cargo_ChargeAmountCannotExceedInvoiceAmount'))
        return false
      }

      return await this.toGenerateInvoiceFaster()
    },
    async toGenerateInvoiceFaster() {
      const selectedRow = this.$refs.invoicePoolCommon.selectedRows[0]
      const allCharges = []
      const chargeMap = {}
      console.log('this.properties.entities', this.properties.entities)
      for (const item of this.properties.entities) {
        const charges = []
        if (this.properties.isGenCostInvoice && item.isOversea && !item.isReceivable) {
          continue
        }
        if (item['entity'] === 'charge' || item.entity === undefined) {
          allCharges.push(item)
          charges.push(item.uuid)
          chargeMap['charge-' + item.uuid] = charges
        }
      }
      if (allCharges.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_OFNBFSWWF'))
        return false
      }
      this.properties.allCharges = allCharges
      this.properties.chargeMap = chargeMap

      if (this.properties && this.properties.invoiceGoodsNameList) {
        this.properties.invoiceGoodsNameList = []
      }
      this.properties.isFei = this.properties && this.properties.groupingMakeType === 1 && (this.properties.interfaceNameEI === InvoiceConstant.INVOICE_BWJSY || this.properties.interfaceNameEI === InvoiceConstant.INVOICE_TAX_EASY_THREE_PLUS || this.properties.interfaceNameEI === InvoiceConstant.INVOICE_NUONUO || this.properties.interfaceNameEI === InvoiceConstant.INVOICE_AISINO_EI || this.properties.toExoSystemYGSH)
      const requestBody = { 'chargeMap': this.properties.chargeMap, 'properties': this.properties, 'invoicePoolUuid': selectedRow.uuid, 'location': this.location }
      const loading = getLoading4Cxt(this)
      await generateInvoiceForPool(requestBody).then(res => {
        this.properties.invoices = res.data
        this.$refs.invoicePoolCommon.selectedRows = []
        this.$refs.invoicePoolCommon.selectedRow = null
        this.$message.warning(this.$t('CargoMsg.Cargo_OperationComplete'))
      }).finally(() => {
        loading.close()
      })
      return true
    },
    async initMakeInvoice() {
      this.properties.makeInvoiceMethod = this.makeInvoiceMethod
      this.properties.branchId = this.$store.getters.currentOfficeId // 分公司
      this.properties.inputByDep = this.$store.getters.currentDeptId // 部门
      this.properties.isHedge = false
      this.properties.typeGroup = 'multi' // 开票类型：multi=合并开票、job=按业务开票、single=按记录开票、settlementAgent=按结算代理开票
      this.properties.currencyGroup = 1 // 分币种开票：0=拆分币种开票、1=合并币种
      this.properties.cbAssignCurrency = true // 指定发票币种
      this.properties.groupingCurrencyType = 0 // currencyGroup + cbAssignCurrency: 0=合并币种、1=拆分币种+指定发票币种、2=拆分币种+非指定发票币种
      this.properties.currency = RateUtil.localCurrencyByOffice() || 'RMB' // 币种
      this.properties.showChargeDetail = false // 是否显示费用明细
      this.properties.useDefaultRate = false // 按财务汇率开票
      this.properties.isInvoicingByBillingRate = false // 按账单汇率
      this.properties.billingRateMap = {} // 账单币种、账单汇率
      this.properties.makeCostInvoice = false // 生成成本发票
      this.properties.isGenCostInvoice = false // 是否生成成本发票: isAr ? makeCostInvoice : false
      this.properties.costInvoiceProp = {}
      this.properties.defaultContent = false // 将本次内容设置为默认开票信息
      this.properties.invoiceGoodsName = {} // 发票项目名称
      this.properties.settleDepartment = 0 // 结算部门
      this.properties.settleDepartmentPrefix = '' // 结算部门归属工作号
      this.properties.otherCurrencys = [] // 其它币种
      this.properties.otherRates = [] // 其它币种汇率
      this.properties.txtCurrency1 = ''
      this.properties.txtRate1 = ''
      this.properties.txtCurrency2 = ''
      this.properties.txtRate2 = ''
      this.properties.rateCache = {} // 对比发票币种的汇率
      this.properties.cbAlwarysUseRate = false // 一直按该汇率开票
      this.properties.isInvoicingByBusinessDateRate = false // 按业务日期汇率收票
      this.properties.isInvoicingByTaxRate = false // 按税点分组开票
      this.properties.autoCheckInvoiceAmountEnable = false
      this.properties.autoCheckInvoicingAmount = this.properties.groupingMakeType === 1 ? Number(cache.config.get('E-InvoiceMaxAmount')) : Number(cache.config.get('InvoiceMaxAmount'))
      // 加载发票种类、发票类型
      this.initMakeInvoiceType()
    },
    async initMakeInvoiceType() {
      const selectedRow = this.$refs.invoicePoolCommon.selectedRows[0]
      this.properties.invoiceType = InvoiceConstant.INVOICE_TYPE_VAT.code // 发票类型：0=普通发票、1=专用发票、2=增值税普通发票、3=增值税专用发票、4=内部发票
      this.properties.groupingMakeType = InvoiceConstant.INVOICE_CATEGORY_ELECTRONIC_INVOICE.code // 发票种类：0=纸质发票、1=电子发票
      //  p:普通发票(电子) c:普通发票(纸质) s:专用发票(纸质) b:专用发票(电子) e:收购发票(电子) f:收购发票(纸质) r:普通发票(卷式) t:增值税电子通行费发票 j:机动车销售统一发票 u二手车发票
      //  bs-电子发票（增值税专用发票），pc-电子发票（增值税普通发票），hk数电票（航空）,tl(数电铁路票)，dj:数电机动车发票(电子) ，sj:数电机动车发票(纸质)，du:数电二手车发票(电子) ，su:数电二手车发票(纸质)
      if (selectedRow.invoiceLine === 'p') {
        this.properties.invoiceType = InvoiceConstant.INVOICE_TYPE_VAT.code
        this.properties.groupingMakeType = InvoiceConstant.INVOICE_CATEGORY_ELECTRONIC_INVOICE.code
      } else if (selectedRow.invoiceLine === 'c') {
        this.properties.invoiceType = InvoiceConstant.INVOICE_TYPE_VAT.code
        this.properties.groupingMakeType = InvoiceConstant.INVOICE_CATEGORY_PAPER_INVOICE.code
      } else if (selectedRow.invoiceLine === 's') {
        this.properties.invoiceType = InvoiceConstant.INVOICE_TYPE_VAT_DEDICATED.code
        this.properties.groupingMakeType = InvoiceConstant.INVOICE_CATEGORY_PAPER_INVOICE.code
      } else if (selectedRow.invoiceLine === 'b') {
        this.properties.invoiceType = InvoiceConstant.INVOICE_TYPE_VAT_DEDICATED.code
        this.properties.groupingMakeType = InvoiceConstant.INVOICE_CATEGORY_ELECTRONIC_INVOICE.code
      } else if (selectedRow.invoiceLine === 'bs') {
        this.properties.invoiceType = InvoiceConstant.INVOICE_TYPE_VAT_FEI.code
        this.properties.groupingMakeType = InvoiceConstant.INVOICE_CATEGORY_ELECTRONIC_INVOICE.code
      } else if (selectedRow.invoiceLine === 'pc') {
        this.properties.invoiceType = InvoiceConstant.INVOICE_TYPE_NORMAL_FEI.code
        this.properties.groupingMakeType = InvoiceConstant.INVOICE_CATEGORY_ELECTRONIC_INVOICE.code
      }
    },
    addKeysFromMaybeCsv(outSet, raw) {
      if (!outSet || raw == null) return
      if (Array.isArray(raw)) {
        for (const it of raw) this.addKeysFromMaybeCsv(outSet, it)
        return
      }
      const str = String(raw).trim()
      if (!str) return
      String(str).split(',').map(s => String(s).trim()).filter(s => s).forEach(s => outSet.add(s))
    },
    async initEntities() {
      this.properties.entities = []
      const keySet = new Set()
      if (this.properties.selectedEntities.length === 0) {
        return false
      }
      // 开票方式: 1=费用、2=业务、3=账单、4=对账单
      if (this.properties.makeInvoiceMethod === 1) {
        for (const item of this.properties.selectedEntities) {
          this.addKeysFromMaybeCsv(keySet, item.uuid)
        }
      } else if (this.properties.makeInvoiceMethod === 2) {
        for (const item of this.properties.selectedEntities) {
          if (this.source === 'invoice') {
            this.addKeysFromMaybeCsv(keySet, item.charges)
          } else {
            this.addKeysFromMaybeCsv(keySet, item.chargeUuids)
          }
        }
      } else if (this.properties.makeInvoiceMethod === 3 || this.properties.makeInvoiceMethod === 4) {
        for (const item of this.properties.selectedEntities) {
          // groupChargeUuids may be comma-separated (e.g. "a,b,c")
          this.addKeysFromMaybeCsv(keySet, item.groupChargeUuids)
        }
      }
      const keys = Array.from(keySet)
      if (keys.length === 0) return false
      const requestBody = { 'keys': keys }
      this.loading = getLoading()
      await getNotInvoiceCharges(requestBody).then(res => {
        this.properties.entities = res.data
      }).finally(() => {
        this.loading.close()
      })
      if (this.properties.entities.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_NoneAnyBillable'))
        return false
      }
      this.properties.allEntities = []
      this.properties.allEntities.push(...this.properties.entities)
      //
      this.properties.invoiceGoodsNameList = []
      this.loading = getLoading()
      await queryInvoiceGoodsName({ 'officeId': this.$store.getters.currentOfficeId }).then(res => {
        this.properties.invoiceGoodsNameList = res.data
      }).finally(() => {
        this.loading.close()
      })
      return true
    }
  }
}
</script>

<style scoped lang="scss">
</style>
